/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Lapse_QInputs */



/**
* | output |
* | --- |
* | "What happens to my rules if the plan ends?" |
*
* @param {Products_Leveling_Faq_Lapse_QInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_lapse_q = /** @type {((inputs?: Products_Leveling_Faq_Lapse_QInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Lapse_QInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что будет с правилами, если тариф закончится?")
	return /** @type {LocalizedString} */ ("What happens to my rules if the plan ends?")
});